import { render, staticRenderFns } from "./UpdateImage.vue?vue&type=template&id=2d7f570e&scoped=true"
import script from "./UpdateImage.vue?vue&type=script&lang=js"
export * from "./UpdateImage.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=2d7f570e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f570e",
  null
  
)

export default component.exports